// extracted by mini-css-extract-plugin
module.exports = {"popoverTrigger":"Popover_popoverTrigger__S4XZf","popoverContent":"Popover_popoverContent__EK89w","popoverArrow":"Popover_popoverArrow__O1RgY"};